import React from 'react';
import ButtonBase from '@mui/material/ButtonBase';

interface IImageButtonProps {
  onClick?: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  src: string;
  alt: string;
}

const ImageButton = ({ onClick, src, alt = '' }: IImageButtonProps) => (
  <ButtonBase
    disableRipple
    onClick={onClick}
    sx={{
      padding: 0,
      borderRadius: 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&:active': {
        backgroundColor: 'transparent',
      },
      '&.Mui-focusVisible': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      },
    }}
  >
    <img src={src} alt={alt} style={{ width: '100%' }} />
  </ButtonBase>
);

export default ImageButton;
